import { render, staticRenderFns } from "./wordpress-headless.vue?vue&type=template&id=f9e701d8&"
import script from "./wordpress-headless.vue?vue&type=script&lang=js&"
export * from "./wordpress-headless.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports